// Lógica de vencimiento de la suscripción, centralizada para que el perfil, soporte
// y los reportes calculen igual (antes estaba duplicada y se desincronizaba).
//
// Fuente de verdad: `pagadoHasta` = la fecha hasta la que el usuario tiene el pago
// cubierto. Para cuentas viejas que todavía no tienen ese campo, se deriva de
// `fechaPago` + la cobertura del plan (anual = 12 meses, mensual = 1).

// Convierte cualquier formato de fecha que use Firestore (Timestamp, {seconds},
// string o Date) a un Date de JS. Devuelve null si no hay valor.
function aDate(valor) {
  if (!valor) return null;
  if (valor.seconds != null) return new Date(valor.seconds * 1000);
  if (typeof valor.toDate === "function") return valor.toDate();
  return new Date(valor);
}

// Fecha hasta la que el usuario tiene pago cubierto (Date) o null si nunca pagó.
export function fechaPagadoHasta(usuario) {
  if (!usuario) return null;

  const ph = aDate(usuario.pagadoHasta);
  if (ph) return ph;

  // Fallback para cuentas previas a pagadoHasta.
  const fp = aDate(usuario.fechaPago);
  if (!fp) return null;
  const cobertura = usuario.plan === "anual" ? 12 : 1;
  const d = new Date(fp);
  d.setMonth(d.getMonth() + cobertura);
  return d;
}

// Meses vencidos: 0 si está al día; ≥1 apenas pasa la fecha de pagadoHasta.
export function mesesVencidos(usuario) {
  const ph = fechaPagadoHasta(usuario);
  if (!ph) return 0;
  const hoy = new Date();
  if (hoy <= ph) return 0;
  let meses = (hoy.getFullYear() - ph.getFullYear()) * 12 + (hoy.getMonth() - ph.getMonth());
  if (hoy.getDate() < ph.getDate()) meses--;
  return Math.max(1, meses);
}

// Lista de meses que el usuario adeuda, como etiquetas ("mayo 2026"), derivada de
// pagadoHasta. La cantidad coincide con mesesVencidos(); cada etiqueta es un mes
// calendario consecutivo empezando por el mes de pagadoHasta (el más viejo primero).
export function mesesPendientes(usuario) {
  const cantidad = mesesVencidos(usuario);
  const ph = fechaPagadoHasta(usuario);
  if (cantidad === 0 || !ph) return [];
  const meses = [];
  for (let i = 0; i < cantidad; i++) {
    const d = new Date(ph);
    d.setMonth(d.getMonth() + i);
    meses.push(d.toLocaleDateString("es-UY", { month: "long", year: "numeric" }));
  }
  return meses;
}

// true si el usuario nunca registró un pago (ni pagadoHasta ni fechaPago).
export function esNuevoUsuario(usuario) {
  return !fechaPagadoHasta(usuario);
}
